<template lang="pug">
  div
    section.content-header
      h1 ユーザー情報変更不可設定
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active ユーザー情報変更不可設定

    section.content
      app-messages(:errorMessages="errors", :successMessages="successes")

      form(@submit.prevent="postData")
        mixin btnbar
          .row.bcard-btnbar(class!=attributes.class)
            .col-sm-6
              button.btn.btn-primary(:disabled="isLoading" type="submit") 変更
              |
              |
              router-link.btn.btn-default(:to="{name: 'admin'}") キャンセル
        +btnbar

        .callout.callout-info.bcard-callout
          p 左端の<strong>チェックボックスをON</strong>にすると、ユーザーが<strong>プロフィール変更画面で変更できる</strong>ようになります。
          p.text-info ※ 入力欄などに表示されているデータはサンプルです。

        //- 読み込み中はぐるぐる表示
        .panel.panel-default(v-if="isLoading")
          loading

        //- 読み込み中は表示しない
        .box.box-widget(v-if="!isLoading")
          .box-header.with-border
            .box-title システム情報

          .box-body
            .row
              .col-xs-11.col-xs-offset-1
                //- ログインID
                checkbox-item(field="loginid", fieldName="ログインID", v-model="loginid", :requiredMark="true", dispValue="yamada")

                //- パスワード
                checkbox-item(field="password", fieldName="パスワード", v-model="password", :requiredMark="true", dispValue="***************")
                  template(slot="dispArea", slot-scope="slotProps")
                    template(v-if="slotProps.value")
                      input.form-control(type="text" :value="slotProps.dispValue")
                    template(v-else)
                      .form-control-static {{ slotProps.dispValue }}

                //- 代表組織
                checkbox-item(field="defgroup", fieldName="代表組織", v-model="defgroup", dispValue="技術部")
                  template(slot="dispArea", slot-scope="slotProps")
                    template(v-if="slotProps.value")
                      select.form-control
                        option {{ slotProps.dispValue }}
                    template(v-else)
                      .form-control-static {{ slotProps.dispValue }}

        //- 読み込み中はぐるぐる表示
        .panel.panel-default(v-if="isLoading")
          loading

        //- 読み込み中は表示しない
        .box.box-widget(v-if="!isLoading")
          .box-header.with-border
            .box-title プロフィール情報

          .box-body
            .row
              .col-xs-11.col-xs-offset-1.bcard-card-addimage
                //- 名刺画像
                //- ダミーデザイン
                checkbox-item(field="image", fieldName="名刺画像", v-model="image", dispValue="")
                  template(slot="dispArea", slot-scope="slotProps")
                    template(v-if="slotProps.value")
                      .form-control.bcard-file-droppable-dummy.-droppable
                        i.fa.fa-image.fa-5x.text-gray
                    template(v-else)
                      .form-control-static.bcard-file-droppable-dummy
                        i.fa.fa-image.fa-5x.text-gray
            .row
              .col-xs-5.col-xs-offset-1
                //- 姓
                checkbox-item(field="lastname", fieldName="姓", v-model="lastname", :requiredMark="true", dispValue="山田")
              .col-xs-5.col-xs-offset-1
                //- 名
                checkbox-item(field="firstname", fieldName="名", v-model="firstname", dispValue="太郎")
            .row
              .col-xs-5.col-xs-offset-1
                //- 姓（よみがな）
                checkbox-item(field="lastname_kana", fieldName="姓（よみがな）", v-model="lastname_kana", :requiredMark="true", dispValue="やまだ")
              .col-xs-5.col-xs-offset-1
                //- 名（よみがな）
                checkbox-item(field="firstname_kana", fieldName="名（よみがな）", v-model="firstname_kana", dispValue="たろう")
            .row
              .col-xs-11.col-xs-offset-1
                //- 会社名
                checkbox-item(field="corpname", fieldName="会社名", v-model="corpname", dispValue="")
            .row
              .col-xs-11.col-xs-offset-1
                //- 会社名（よみがな）
                checkbox-item(field="corpname_kana", fieldName="会社名（よみがな）", v-model="corpname_kana", dispValue="")
            .row
              .col-xs-11.col-xs-offset-1
                //- 部署名
                checkbox-item(field="dept", fieldName="部署名", v-model="dept", dispValue="")
                  template(slot="dispArea", slot-scope="slotProps")
                    template(v-if="slotProps.value")
                      input.form-control(type="text" value="技術部")
                    template(v-else)
                      .form-control-static 技術部
            .row
              .col-xs-11.col-xs-offset-1
                //- 役職
                checkbox-item(field="post", fieldName="役職", v-model="post", dispValue="")
            .row
              .col-xs-11.col-xs-offset-1
                //- 住所
                checkbox-item(field="address", fieldName="住所", v-model="address", dispValue="")
                  template(slot="dispArea", slot-scope="slotProps")
                    template(v-if="slotProps.value")
                      .form-inline
                        .input-group
                          .input-group-addon 〒
                          input.form-control(type="text" value="")
                      input.form-control(type="text" value="")
                      input.form-control(type="text" value="")
                    template(v-else)
                      .form-control-static 〒 {{app_lang.NO_INPUT}}
                      .form-control-static {{app_lang.NO_INPUT}}
                      .form-control-static {{app_lang.NO_INPUT}}
            .row
              .col-xs-11.col-xs-offset-1
                //- 会社電話
                checkbox-item(field="corp_tel", fieldName="会社電話", v-model="corp_tel", dispValue="")
            .row
              .col-xs-11.col-xs-offset-1
                //- 部署電話
                checkbox-item(field="dept_tel", fieldName="部署電話", v-model="dept_tel", dispValue="")
            .row
              .col-xs-11.col-xs-offset-1
                //- 内線
                checkbox-item(field="naisen", fieldName="内線", v-model="naisen", dispValue="")
            .row
              .col-xs-11.col-xs-offset-1
                //- 携帯電話
                checkbox-item(field="hand_tel", fieldName="携帯電話", v-model="hand_tel", dispValue="")
            .row
              .col-xs-11.col-xs-offset-1
                //- FAX
                checkbox-item(field="fax", fieldName="FAX", v-model="fax", dispValue="")
            .row
              .col-xs-11.col-xs-offset-1
                //- メールアドレス
                checkbox-item(field="mail", fieldName="メールアドレス", v-model="mail", dispValue="yamada@mydomain")
            .row
              .col-xs-11.col-xs-offset-1
                //- URL
                checkbox-item(field="url", fieldName="URL", v-model="url", dispValue="")

        +btnbar.-bottom

</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import checkboxItem from './_UserSetting_checkbox-item'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const UserSettingRepository = RepositoryFactory.get('usersetting')

export default {
  name: 'UserSetting',
  components: { AppMessages, checkboxItem, Loading },
  data: function () {
    return {
      attachsize: '',
      attachsizeoptions: [],
      loginid: true,
      password: true,
      defgroup: true,
      image: true,
      lastname: true,
      firstname: true,
      lastname_kana: true,
      firstname_kana: true,
      corpname: true,
      corpname_kana: true,
      dept: true,
      post: true,
      address: true,
      corp_tel: true,
      dept_tel: true,
      naisen: true,
      hand_tel: true,
      fax: true,
      mail: true,
      url: true,

      isLoading: true // 読み込み中かどうか
    }
  },
  created: function () {
    const vm = this

    // API実行
    UserSettingRepository.get()
      .then(function (response) {
        const data = vm.getApiData(response).data
        vm.loginid = data.loginid
        vm.password = data.password
        vm.defgroup = data.defgroup
        vm.image = data.image
        vm.lastname = data.lastname
        vm.firstname = data.firstname
        vm.lastname_kana = data.lastname_kana
        vm.firstname_kana = data.firstname_kana
        vm.corpname = data.corpname
        vm.corpname_kana = data.corpname_kana
        vm.dept = data.dept
        vm.post = data.post
        vm.address = data.address
        vm.corp_tel = data.corp_tel
        vm.dept_tel = data.dept_tel
        vm.naisen = data.naisen
        vm.hand_tel = data.hand_tel
        vm.fax = data.fax
        vm.mail = data.mail
        vm.url = data.url

        vm.isLoading = false
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
  },
  methods: {
    // ファイルサイズ設定の登録・更新
    postData () {
      const vm = this

      // API実行
      UserSettingRepository.put({
        loginid: vm.loginid,
        password: vm.password,
        defgroup: vm.defgroup,
        image: vm.image,
        lastname: vm.lastname,
        firstname: vm.firstname,
        lastname_kana: vm.lastname_kana,
        firstname_kana: vm.firstname_kana,
        corpname: vm.corpname,
        corpname_kana: vm.corpname_kana,
        dept: vm.dept,
        post: vm.post,
        address: vm.address,
        corp_tel: vm.corp_tel,
        dept_tel: vm.dept_tel,
        naisen: vm.naisen,
        hand_tel: vm.hand_tel,
        fax: vm.fax,
        mail: vm.mail,
        url: vm.url
      }).then(function () {
        // 成功時は設定状況に遷移
        vm.$router.push({name: 'admin'})
      }).catch(function (error) {
        // エラー時はメッセージを表示
        vm.setErrorMessage(error)
      })
    }
  }
}
</script>

<!-- ユーザー内共通CSS -->
<style lang="scss" scoped>
@import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';
.bcard-file-droppable-dummy {
  position: relative;
  height: 260px; // 各画面で上書き可能
  line-height: 260px;
  margin: 3px;

  overflow: hidden;
  text-align: center;
  // color: #fff;
  background: $gray-lighter;
  box-sizing: border-box;

  &.-droppable {
    border: 2px dashed $gray-light;
    outline: 3px solid $gray-lighter;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/envsettings/UserSetting.vue